import { PropertyValue } from "src/context/Property/Builder/PropertyBuilder";
import { OnUpdate } from ".";
import { FoodsRadioList } from "@foodpilot/foods";
import { DataListOption } from "src/api/sure-api/ssq/useGetOneSsq";
import {
    deserializeOptionsFromProperty,
    serializeOptionsFromProperty,
} from "src/context/Property/PropertyValueSerializer";
import { useState } from "react";

type RadioProps = {
    property: PropertyValue;
    updatePropertyValue: (options: OnUpdate) => void;
    isLocked?: boolean;
};
export const Radio = (props: RadioProps) => {
    const { property, updatePropertyValue, isLocked = false } = props;
    const options = property.property.dataList?.options;

    const values = deserializeOptionsFromProperty(property);
    const [selectedValue, setValue] = useState(values.value);

    return (
        <FoodsRadioList
            selectedItem={selectedValue}
            values={options ?? []}
            getId={(option) => option.value}
            getName={(option) => option.label}
            RadioProps={{
                disabled: isLocked,
            }}
            onChange={(newValue: DataListOption) => {
                setValue(newValue);
                const serializedValue = serializeOptionsFromProperty(newValue);
                updatePropertyValue({
                    serializedString: serializedValue.value,
                    dataListOptionIds: serializedValue.dataListOptionIds,
                    calculationType: "action",
                });
            }}
            FormControlProps={{
                sx: {
                    flexDirection: "column",
                },
            }}
        />
    );
};
